export const products = {
    newArrivals: [
        {
            id: 1,
            category: "ENGINE OIL",
            name: "CALTEX ENGINE OIL",
            image: "./assets/Engine Oil.jpg",
        },
        {
            id: 2,
            category: "ALL BATTERIES",
            name: "FIAMM BATTERY",
            image: "./assets/battery.avif",
        },
        {
            id: 3,
            category: "TIRE",
            name: "FIRESTONE TIRE",
            image: "./assets/tire.jpg",
        },
        {
            id: 4,
            category: "STEERING SUSPENSION",
            name: "KYB STEERING SUSPENSION",
            image: "./assets/power.jpg",
        }
    ],
    featured: [
        {
            id: 5,
            name: "Aisin",
            image: "./assets/aisin.png",
        },
        {
            id: 6,
            name: "Art",
            image: "./assets/ART-300x300.png",
        },
        {
            id: 7,
            name: "Advics",
            image: "./assets/ADVICS-300x300 (1).png",
        }
    ],
    popular: [
        {
            id: 8,
            category: "ENGINE OIL",
            name: "CALTEX ENGINE OIL",
            image: "./assets/Engine Oil.jpg",
        },
        {
            id: 9,
            category: "ALL BATTERIES",
            name: "FIAMM BATTERY",
            image: "./assets/battery.avif",
        },
        {
            id: 10,
            category: "FUEL PARTS",
            name: "DENSO FUEL PUMP",
            image: "./assets/FuelPump.jpg",
        },
    ]
};